(() => {
  const compactLocalPrice = (root = document) => {
    root.querySelectorAll('[data-yy-local-amount]').forEach((node) => {
      if (node.dataset.yyCompactObserved === 'true') return;
      node.dataset.yyCompactObserved = 'true';

      const compact = () => {
        const text = node.textContent.trim();
        const prefix = 'Approx. ';
        const suffix = ' in your currency';

        if (text.startsWith(prefix) && text.endsWith(suffix)) {
          node.textContent = `≈ ${text.slice(prefix.length, -suffix.length)}`;
        }
      };

      compact();

      new MutationObserver(compact).observe(node, {
        childList: true,
        characterData: true,
        subtree: true,
      });
    });
  };

  const initBar = (bar) => {
    if (bar.dataset.yyInitialized === 'true') return;

    const stickyButton = bar.querySelector('[data-yy-sticky-add]');
    if (!stickyButton) return;

    bar.dataset.yyInitialized = 'true';

    const getMainButton = () =>
      document.querySelector('product-info .product-form__submit')
      || document.querySelector('#MainContent .product-form__submit')
      || null;

    let observedButton = null;
    let visibilityFrame = null;

    const buttonObserver = new MutationObserver(() => {
      sync();
      requestVisibilityUpdate();
    });

    const bindMainButton = () => {
      const currentButton = getMainButton();

      if (currentButton !== observedButton) {
        buttonObserver.disconnect();
        observedButton = currentButton;

        if (observedButton) {
          buttonObserver.observe(observedButton, {
            attributes: true,
            attributeFilter: ['disabled'],
            childList: true,
            subtree: true,
            characterData: true,
          });
        }
      }

      return currentButton;
    };

    const sync = () => {
      const mainButton = bindMainButton();

      if (!mainButton) {
        stickyButton.disabled = true;
        return;
      }

      stickyButton.disabled = mainButton.disabled;

      const label = mainButton.querySelector('span')?.textContent?.trim();
      if (label) stickyButton.textContent = label;
    };

    const updateVisibility = () => {
      visibilityFrame = null;

      const mainButton = bindMainButton();

      if (!mainButton || !mainButton.isConnected) {
        bar.classList.remove('is-visible');
        bar.setAttribute('aria-hidden', 'true');
        return;
      }

      const rect = mainButton.getBoundingClientRect();
      const footer = document.querySelector('footer.footer') || document.querySelector('footer');
      const viewportHeight = window.visualViewport?.height || window.innerHeight;
      const footerRect = footer?.getBoundingClientRect();
      const footerVisible = Boolean(
        footerRect
        && footerRect.top < viewportHeight
        && footerRect.bottom > 0
      );
      const show = rect.bottom < 0 && !footerVisible;

      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    };

    const requestVisibilityUpdate = () => {
      if (visibilityFrame !== null) return;
      visibilityFrame = window.requestAnimationFrame(updateVisibility);
    };

    const mainContent = document.getElementById('MainContent');

    if (mainContent) {
      const productObserver = new MutationObserver(() => {
        sync();
        requestVisibilityUpdate();
      });

      productObserver.observe(mainContent, {
        childList: true,
        subtree: true,
      });
    }

    sync();
    updateVisibility();

    window.addEventListener('scroll', requestVisibilityUpdate, { passive: true });
    window.addEventListener('resize', requestVisibilityUpdate);

    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', requestVisibilityUpdate);
      window.visualViewport.addEventListener('scroll', requestVisibilityUpdate);
    }

    stickyButton.addEventListener('click', () => {
      const mainButton = getMainButton();

      if (mainButton && !mainButton.disabled) {
        mainButton.click();
      }
    });
  };

  const init = (root = document) => {
    compactLocalPrice(root);

    const bar = document.querySelector('[data-yy-sticky-product-bar]');
    if (bar) initBar(bar);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', () => init());
})();
